<template>
  <dx-cell v-bind="$attrs" v-on="$listeners" :class="this.$attrs.column.className ? this.$attrs.column.className($attrs.tableRow.row) : ''">
    <a
      href="javascript:void(0)"
      v-on:click="remove($attrs.tableRow.row.id, $attrs.column.isDeleteWithConfirm)"
      :title="title"
      v-b-tooltip.hover 
      v-if="!$attrs.tableRow.row.isImpersonate"
    >
      <i :class="icon"></i>
    </a>
    <i v-if="$attrs.tableRow.row.isImpersonate" :title="title" :class="icon"></i>
  </dx-cell>
</template>

<script>
import { DxGrid, DxTable } from '@devexpress/dx-vue-grid-bootstrap4';
import Cell from './Cell';
import axios from 'axios';

export default {
  inheritAttrs: false,
  props: ['value'],
  components: {
    DxCell: DxTable.components.DxCell,
  },
  methods: {
    remove: function(id, isDeleteWithConfirm = true) {
      if (this.$attrs.tableRow.row.isImpersonate) {
        return;
      }
      if(isDeleteWithConfirm) {
        this.$swal({
        icon: 'warning',
        title: this.$t('Предупреждение'),
        text: this.$attrs.tableRow.row.isDeleted ? 
        this.$t('Вы уверены, что хотите восстановить эту запись?') 
           : this.$t('Вы уверены, что хотите удалить эту запись?')
        ,
        buttons: [this.$t('Нет'), this.$t('Да')],
        }).then((willDelete) => {
          if (willDelete) {
            this.removeWithoutConfirm(id);
          }
        });
      } else {
        this.removeWithoutConfirm(id);
      }
    },
    removeWithoutConfirm(id) {
      if(!this.$attrs.column.action) {
        let path = this.$route.path + '?id=' + id;
        if(this.$attrs.column.urlPrefix) {
          path = '/' + this.$attrs.column.urlPrefix + path;
        }
        axios.delete(path)
        .then((response) => {
          this.$router.go({
            path: this.$route.path,
            force: true,
          });
        })
        .catch((e) => {
          this.$swal({icon: 'error', title: this.$attrs.tableRow.row.isDeleted ? this.$t('Нельзя восстановить запись') :  this.$t('Нельзя удалить запись'),
            text: e.data.message,
            dangerMode: true,
          });
        });
      } else {
        this.$attrs.column.action(id);
      }
    }
  },
  computed: {
    title() {
      if (this.$attrs.tableRow.row.isImpersonate) {
        return this.$t('Имперсонифицированный пользователь');
      }
      return this.$attrs.tableRow.row.isDeleted ? this.$t('Восстановить') : this.$t('Удалить');
    },
    icon() {
      if (this.$attrs.tableRow.row.isImpersonate) {
        return 'fa fa-user-secret';
      }
      return this.$attrs.tableRow.row.isDeleted
        ? 'fa fa-trash-restore-alt'
        : 'fa fa-trash-alt';
    },
  },
};
</script>

<style>
.swal-button--confirm {
  background-color: #009688 !important;
}
.swal-footer {
    display: flex;
    flex-flow: row-reverse;
}
</style>
